import React from 'react';
import { Avatar, Button, Space, Tag, Typography } from 'antd';
import { AppstoreOutlined, WhatsAppOutlined } from '@ant-design/icons';
import useAccountNavigate from '../../hooks/useAccountNavigate';

const { Title, Text } = Typography;

const BRAND = '#f5721d';
const BRAND_SOFT = '#fff3ea';
const BRAND_BORDER = '#ffd8bf';
const CSM_WHATSAPP = '573103235693';

const ProductNotEnabled = ({ productName, accountName }) => {
  const { navigate, accountId } = useAccountNavigate();
  const displayName = productName || 'Este producto';
  const namedAccount = accountName || (accountId ? `la cuenta ${accountId}` : 'tu cuenta');
  const message = encodeURIComponent(
    `Hola, quiero activar ${displayName} en ${namedAccount}${
      accountId ? ` (ID ${accountId})` : ''
    }.`
  );

  return (
    <section
      aria-labelledby="product-locked-title"
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        margin: -16,
        minHeight: 'calc(100vh - 152px)',
        background: '#fff',
      }}
    >
      <div style={{ height: 5, background: `linear-gradient(90deg, ${BRAND}, #ff9a4d)`, flex: 'none' }} />
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '48px 32px',
        }}
      >
        <div style={{ width: '100%', maxWidth: 520 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
            <Avatar
              shape="square"
              size={64}
              icon={<AppstoreOutlined />}
              style={{
                background: BRAND_SOFT,
                color: BRAND,
                border: `1px solid ${BRAND_BORDER}`,
                borderRadius: 12,
                fontSize: 28,
                flex: 'none',
              }}
            />
            <div style={{ minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                <Title id="product-locked-title" level={3} style={{ margin: 0 }}>
                  {displayName}
                </Title>
                <Tag style={{ margin: 0 }}>No activo</Tag>
              </div>
              <Text type="secondary">Aún no está en {namedAccount}</Text>
            </div>
          </div>

          <Text style={{ display: 'block', marginBottom: 24, color: 'rgba(0,0,0,0.65)' }}>
            Tu CSM puede activarlo para que quede disponible en este panel, sobre la misma cuenta y sin instalar nada.
          </Text>

          <Space wrap>
            <Button
              type="primary"
              icon={<WhatsAppOutlined />}
              href={`https://wa.me/${CSM_WHATSAPP}?text=${message}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Escribir a tu CSM
            </Button>
            <Button onClick={() => navigate('/home')}>
              Volver al inicio
            </Button>
          </Space>
        </div>
      </div>
    </section>
  );
};

export default ProductNotEnabled;
